export const userActivityLogAction = {
  setSelectedUser: (state, action) => {
    state.selectedUser = action.payload;
  },

  setUserTransmissionProgressData: (state, action) => {
    state.userTransmissionProgressData = action.payload;
  },

  setTopUserTransmissionProgressData: (state, action) => {
    state.topUserTransmissionProgressData = action.payload;
  },
};
